export default "__VITE_ASSET__db3ce448__"